import FolderIcon from "@/components/icons/folder-solid";
import PDFIcon from "@/components/icons/pdf-solid";
import DocIcon from "@/components/icons/doc-solid";
import ImageIcon from "@/components/icons/image-solid";
import XMLIcon from "@/components/icons/xml-solid";

export const fileGridData = [
  {
    id: "14659",
    file: {
      name: "across_baggy_shark.jpg",
      image: <ImageIcon />,
    },
    size: "1.3MB",
    type: "image",
    totalFiles: "6",
    modified: "2023-08-23T17:46:22.831Z",
  },
  {
    id: "00226",
    file: {
      name: "how.xml",
      image: <XMLIcon />,
    },
    size: "7.8GB",
    type: "xml",
    totalFiles: "500",
    modified: "2023-10-28T21:17:10.858Z",
  },
  {
    id: "15082",
    file: {
      name: "athwart_loafer_appropriate.doc",
      image: <DocIcon />,
    },
    size: "3.1GB",
    type: "doc",
    totalFiles: "871",
    modified: "2023-06-20T12:05:08.402Z",
  },
  {
    id: "81769",
    file: {
      name: "Kookily unimpressively",
      image: <FolderIcon />,
    },
    size: "9.4MB",
    type: "folder",
    totalFiles: "14",
    modified: "2023-01-04T15:14:44.180Z",
  },
  {
    id: "97182",
    file: {
      name: "failing_despite.png",
      image: <ImageIcon />,
    },
    size: "9.3MB",
    type: "image",
    totalFiles: "063",
    modified: "2023-07-09T06:55:27.000Z",
  },
  {
    id: "69593",
    file: {
      name: "Few unlike tanker",
      image: <FolderIcon />,
    },
    size: "3.5GB",
    type: "folder",
    totalFiles: "1",
    modified: "2023-04-27T15:58:51.428Z",
  },
  {
    id: "74441",
    file: {
      name: "glass_less.xml",
      image: <XMLIcon />,
    },
    size: "9.1MB",
    type: "xml",
    totalFiles: "59",
    modified: "2024-03-20T17:47:47.620Z",
  },
  {
    id: "02993",
    file: {
      name: "recklessly_whenever.doc",
      image: <DocIcon />,
    },
    size: "3.5MB",
    type: "doc",
    totalFiles: "39",
    modified: "2023-04-19T11:10:10.810Z",
  },
  {
    id: "80686",
    file: {
      name: "Anthem view",
      image: <FolderIcon />,
    },
    size: "9.3GB",
    type: "folder",
    totalFiles: "466",
    modified: "2023-10-10T19:11:06.759Z",
  },
  {
    id: "10265",
    file: {
      name: "which_scrawny_jeep.xml",
      image: <XMLIcon />,
    },
    size: "9GB",
    type: "xml",
    totalFiles: "29",
    modified: "2024-03-11T15:47:46.793Z",
  },
  {
    id: "05241",
    file: {
      name: "er_jealously.gif",
      image: <ImageIcon />,
    },
    size: "9.6MB",
    type: "image",
    totalFiles: "9",
    modified: "2024-02-22T08:47:57.659Z",
  },
  {
    id: "99185",
    file: {
      name: "furthermore_zesty_yuck.xml",
      image: <XMLIcon />,
    },
    size: "4.5MB",
    type: "xml",
    totalFiles: "1",
    modified: "2023-05-08T13:15:41.502Z",
  },
  {
    id: "89379",
    file: {
      name: "warped_brr_factor.gif",
      image: <ImageIcon />,
    },
    size: "9.9MB",
    type: "image",
    totalFiles: "32",
    modified: "2023-03-11T17:08:45.295Z",
  },
  {
    id: "18022",
    file: {
      name: "white.doc",
      image: <DocIcon />,
    },
    size: "8.4MB",
    type: "doc",
    totalFiles: "041",
    modified: "2023-07-09T03:57:40.658Z",
  },
  {
    id: "80904",
    file: {
      name: "awe.jpeg",
      image: <ImageIcon />,
    },
    size: "7.4MB",
    type: "image",
    totalFiles: "55",
    modified: "2023-10-28T05:22:22.939Z",
  },
  {
    id: "08687",
    file: {
      name: "wearily.svg",
      image: <ImageIcon />,
    },
    size: "9.8GB",
    type: "image",
    totalFiles: "785",
    modified: "2023-12-28T11:31:52.402Z",
  },
  {
    id: "30662",
    file: {
      name: "turbocharge_slack.doc",
      image: <DocIcon />,
    },
    size: "2GB",
    type: "doc",
    totalFiles: "113",
    modified: "2023-05-06T09:21:28.523Z",
  },
  {
    id: "15582",
    file: {
      name: "Forduh ",
      image: <FolderIcon />,
    },
    size: "4.5GB",
    type: "folder",
    totalFiles: "64",
    modified: "2023-06-12T07:08:33.501Z",
  },
  {
    id: "51614",
    file: {
      name: "skeletal.pdf",
      image: <PDFIcon />,
    },
    size: "3.6MB",
    type: "pdf",
    totalFiles: "0",
    modified: "2023-03-18T20:10:41.079Z",
  },
  {
    id: "81563",
    file: {
      name: "Offence negligible whoa",
      image: <FolderIcon />,
    },
    size: "5.4GB",
    type: "folder",
    totalFiles: "55",
    modified: "2023-08-31T23:53:50.110Z",
  },
  {
    id: "37093",
    file: {
      name: "volcano_questioningly.xml",
      image: <XMLIcon />,
    },
    size: "9.9GB",
    type: "xml",
    totalFiles: "38",
    modified: "2022-11-03T11:35:59.734Z",
  },
  {
    id: "54389",
    file: {
      name: "economy_flippant_honestly.webp",
      image: <ImageIcon />,
    },
    size: "9.2GB",
    type: "image",
    totalFiles: "6",
    modified: "2024-03-28T03:08:48.574Z",
  },
  {
    id: "73655",
    file: {
      name: "washcloth_skullduggery_separately.pdf",
      image: <PDFIcon />,
    },
    size: "9.5GB",
    type: "pdf",
    totalFiles: "3",
    modified: "2023-02-11T11:11:02.746Z",
  },
  {
    id: "27959",
    file: {
      name: "Within",
      image: <FolderIcon />,
    },
    size: "8.2MB",
    type: "folder",
    totalFiles: "66",
    modified: "2023-02-09T21:46:30.165Z",
  },
  {
    id: "85388",
    file: {
      name: "sedately_furthermore.doc",
      image: <DocIcon />,
    },
    size: "9.2GB",
    type: "doc",
    totalFiles: "4",
    modified: "2023-07-14T15:27:49.170Z",
  },
  {
    id: "78053",
    file: {
      name: "Focused woefully ",
      image: <FolderIcon />,
    },
    size: "8.4GB",
    type: "folder",
    totalFiles: "563",
    modified: "2022-11-06T20:09:30.083Z",
  },
  {
    id: "13663",
    file: {
      name: "Great grandmother checkmate",
      image: <FolderIcon />,
    },
    size: "6.6MB",
    type: "folder",
    totalFiles: "99",
    modified: "2024-05-30T00:57:09.622Z",
  },
  {
    id: "33684",
    file: {
      name: "node_gee.doc",
      image: <DocIcon />,
    },
    size: "3.4GB",
    type: "doc",
    totalFiles: "2",
    modified: "2022-10-25T10:23:47.244Z",
  },
  {
    id: "40359",
    file: {
      name: "Covariate",
      image: <FolderIcon />,
    },
    size: "7.4MB",
    type: "folder",
    totalFiles: "8",
    modified: "2024-01-01T17:41:12.690Z",
  },
  {
    id: "78069",
    file: {
      name: "gamma_ray_pfft_paragraph.webp",
      image: <ImageIcon />,
    },
    size: "2.5MB",
    type: "image",
    totalFiles: "03",
    modified: "2024-02-17T06:54:07.640Z",
  },
  {
    id: "70121",
    file: {
      name: "contract_properly.jpeg",
      image: <ImageIcon />,
    },
    size: "3.8GB",
    type: "image",
    totalFiles: "43",
    modified: "2022-09-28T23:58:37.004Z",
  },
  {
    id: "17381",
    file: {
      name: "Inhibitor",
      image: <FolderIcon />,
    },
    size: "9.1GB",
    type: "folder",
    totalFiles: "318",
    modified: "2023-01-28T22:31:30.786Z",
  },
  {
    id: "72393",
    file: {
      name: "Short term kid",
      image: <FolderIcon />,
    },
    size: "1.1GB",
    type: "folder",
    totalFiles: "070",
    modified: "2022-11-27T07:42:55.042Z",
  },
  {
    id: "80515",
    file: {
      name: "rapidly.doc",
      image: <DocIcon />,
    },
    size: "8.3GB",
    type: "doc",
    totalFiles: "0",
    modified: "2023-05-06T21:25:21.233Z",
  },
  {
    id: "43569",
    file: {
      name: "given_dream_mmm.doc",
      image: <DocIcon />,
    },
    size: "2.4MB",
    type: "doc",
    totalFiles: "548",
    modified: "2023-02-08T09:06:56.104Z",
  },
  {
    id: "86430",
    file: {
      name: "tabletop_shakily_beside.doc",
      image: <DocIcon />,
    },
    size: "4.3GB",
    type: "doc",
    totalFiles: "1",
    modified: "2024-07-07T01:54:34.054Z",
  },
  {
    id: "26611",
    file: {
      name: "hm_fooey_yet.png",
      image: <ImageIcon />,
    },
    size: "8.4GB",
    type: "image",
    totalFiles: "363",
    modified: "2023-05-01T05:38:00.346Z",
  },
  {
    id: "29599",
    file: {
      name: "into_correctly_upside_down.xml",
      image: <XMLIcon />,
    },
    size: "9.3GB",
    type: "xml",
    totalFiles: "21",
    modified: "2024-01-28T21:51:24.413Z",
  },
  {
    id: "94557",
    file: {
      name: "yummy_sponsor_apud.doc",
      image: <DocIcon />,
    },
    size: "6.1MB",
    type: "doc",
    totalFiles: "810",
    modified: "2023-02-07T23:12:10.355Z",
  },
  {
    id: "16134",
    file: {
      name: "troubled_dill_phooey.gif",
      image: <ImageIcon />,
    },
    size: "7.7GB",
    type: "image",
    totalFiles: "15",
    modified: "2024-04-10T18:48:19.381Z",
  },
  {
    id: "12661",
    file: {
      name: "partially_freely.pdf",
      image: <PDFIcon />,
    },
    size: "2.9MB",
    type: "pdf",
    totalFiles: "3",
    modified: "2023-02-01T23:02:43.262Z",
  },
  {
    id: "00231",
    file: {
      name: "chortle.png",
      image: <ImageIcon />,
    },
    size: "4.2MB",
    type: "image",
    totalFiles: "33",
    modified: "2023-04-26T03:04:06.303Z",
  },
  {
    id: "79506",
    file: {
      name: "fat_along_aha.xml",
      image: <XMLIcon />,
    },
    size: "3.3MB",
    type: "xml",
    totalFiles: "41",
    modified: "2023-02-05T21:40:43.794Z",
  },
  {
    id: "51352",
    file: {
      name: "invent_past_aw.png",
      image: <ImageIcon />,
    },
    size: "2.3GB",
    type: "image",
    totalFiles: "04",
    modified: "2023-08-02T16:56:31.459Z",
  },
  {
    id: "65959",
    file: {
      name: "ah_personal_ugh.doc",
      image: <DocIcon />,
    },
    size: "7.7MB",
    type: "doc",
    totalFiles: "193",
    modified: "2023-01-25T08:45:21.713Z",
  },
];
